import { Popup } from 'devextreme-react'
import { Column, Item, Toolbar } from 'devextreme-react/data-grid'
import Cookies from 'js-cookie'
import moment from 'moment'
import React from 'react'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid'
import api from '../../../services/api-configuration'
import useFormatMessage from '../../../utils/useFormatMessage'
import DamageReportForm from '../../hasar-bildirimi/components/DamageReportForm'
const Hasarlar = ({ data, setTrigger, trigger }) => {
    const { t } = useFormatMessage()
    const [popupVisible, setPopupVisible] = React.useState(false)

    const handleAddData = async (data) => {
        let body = {
            "damage_date": moment(data.damage_date).format("YYYY-MM-DD HH:mm:ss"),
            "chassis_no": data.chassis_no,
            "damage_region": data.damage_region,
            "reporter_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            "responsible": data.responsible,
            "description": data.description
        }
        const image = data.image || null;

        const formData = new FormData();
        formData.append("data", JSON.stringify(body));
        if (image) formData.append("image", image);


        try {

            const response = await api.post('/damage/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            toast.success("Hasar bildirimi başarılı")
            setTrigger(!trigger)

        } catch (error) {
            toast.error("BAŞARIZ: " + t(error.response.data.error))
        } finally {
            // getAllDamegeReport();
        }

    }

    const token = 'Bearer ' + Cookies.get('token')

    const renderGridCell = (cellData) => (
        <div style={{
            cursor: "pointer",
            visibility: cellData.data.image_path ? "visible" : "hidden"
        }}>
            <img
                src={"http://172.17.0.1/api/v1/image?image_path=" + cellData.data.image_path}
                style={{ width: 50, height: 50 }}
                onClick={() => {
                    Swal.fire({
                        title: '',
                        text: cellData.data.description || "",
                        imageUrl: "http://172.17.0.1/api/v1/image?image_path=" + cellData.data.image_path,
                        imageWidth: 450,
                        imageAlt: 'hasar image',
                        showCancelButton: true, // Kapat butonunu göster
                        cancelButtonText: 'Kapat', // Kapat butonunun metni
                        showConfirmButton: false, // Tamam butonunu gizle
                    });
                }}
            />
        </div>
    );
    return (
        <>
            <DatagridCustom dataSource={data} >


                <Column dataField="process_date" caption={t("Tarih")}
                    dataType='datetime'
                    format='dd/MM/yyyy HH:mm'
                />
                <Column dataField="region" caption={t("Bölge")} />
                <Column dataField="reporter" caption={t("Raporlayan")} />
                <Column dataField="responsible" caption={t("Sorumlu")} />
                <Column dataField="description" caption={t("Açıklama")} />
                <Column
                    dataField="image_path"
                    width={120}
                    caption={t("Hasar Görseli")}
                    cellRender={renderGridCell}
                />

                <Toolbar>
                    <Item
                        visible={data}
                        location="after" widget="dxButton" options={{
                            text: t("Hasar Ekle"), icon: 'add', type: 'default',
                            onClick: () => {
                                setPopupVisible(true)
                            }
                        }}
                    />

                </Toolbar>
            </DatagridCustom>
            {data && <Popup
                title={t("Hasar Ekle")}
                visible={popupVisible}
                onHiding={() => setPopupVisible(false)}
                width={"50%"}
                height={500}

            >
                <DamageReportForm
                    onClose={() => setPopupVisible(false)}
                    sase_disabled={true}
                    default_sase={document.getElementById("sase-value")?.value}
                    onSubmit={async (formData) => {
                        // Form verilerini işleme ve API'ye gönderm
                        try {
                            // API çağrısı yapılabilir
                            await handleAddData(formData);
                            setPopupVisible(false);
                        } catch (error) {
                            toast.error(error.response?.data?.message || 'Bir hata oluştu');
                        }
                    }}
                />
            </Popup>}
        </>
    )
}

export default Hasarlar